import {
  normalizeRoles,
  isGlobalReporting,
  isSuperRegionalReporting,
  isCountryReporting,
} from "../util/roleHelpers";

// export const POWER_BI_LINKS = {
//   GLOBAL_REPORTING:
//     "https://app.powerbi.com/reportEmbed?reportId=14ec4b4d-5d39-4e8c-8066-ad2724b7f4ed&autoAuth=true&ctid=5b973f99-77df-4beb-b27d-aa0c70b8482c",
//   SUPER_REGIONAL_ADN:
//     "https://app.powerbi.com/reportEmbed?reportId=14ec4b4d-5d39-4e8c-8066-ad2724b7f4ed&autoAuth=true&ctid=5b973f99-77df-4beb-b27d-aa0c70b8482c",
//   SUPER_REGIONAL_AOA:
//     "https://app.powerbi.com/reportEmbed?reportId=14ec4b4d-5d39-4e8c-8066-ad2724b7f4ed&autoAuth=true&ctid=5b973f99-77df-4beb-b27d-aa0c70b8482c",
//   COUNTRY_ADN:
//     "https://app.powerbi.com/reportEmbed?reportId=14ec4b4d-5d39-4e8c-8066-ad2724b7f4ed&autoAuth=true&ctid=5b973f99-77df-4beb-b27d-aa0c70b8482c",
//   COUNTRY_AOA:
//     "https://app.powerbi.com/reportEmbed?reportId=14ec4b4d-5d39-4e8c-8066-ad2724b7f4ed&autoAuth=true&ctid=5b973f99-77df-4beb-b27d-aa0c70b8482c",
// };
// Power BI report link. The environment-specific report is injected at build time
// via REACT_APP_POWERBI_URL (set per environment in the Azure pipelines). When the
// variable is not set it falls back to the PROD "AXON - Service Manager Reporting"
// report so production stays correct even if the variable is missing.
const POWER_BI_REPORT_URL =
  process.env.REACT_APP_POWERBI_URL ||
  "https://app.powerbi.com/reportEmbed?reportId=f4ae36cd-1a70-40d8-82ef-f7838acb5910&autoAuth=true&ctid=5b973f99-77df-4beb-b27d-aa0c70b8482c";

export const POWER_BI_LINKS = {
  GLOBAL_REPORTING: POWER_BI_REPORT_URL,
  SUPER_REGIONAL_ADN: POWER_BI_REPORT_URL,
  SUPER_REGIONAL_AOA: POWER_BI_REPORT_URL,
  COUNTRY_ADN: POWER_BI_REPORT_URL,
  COUNTRY_AOA: POWER_BI_REPORT_URL,
};

export function getPowerBiLink(role, coe) {
  const roles = normalizeRoles(role);
  const c = String(coe || "").toUpperCase();

  if (isGlobalReporting(roles)) return POWER_BI_LINKS.GLOBAL_REPORTING;
  if (isSuperRegionalReporting(roles))
    return c === "AOA"
      ? POWER_BI_LINKS.SUPER_REGIONAL_AOA
      : POWER_BI_LINKS.SUPER_REGIONAL_ADN;
  if (isCountryReporting(roles))
    return c === "AOA"
      ? POWER_BI_LINKS.COUNTRY_AOA
      : POWER_BI_LINKS.COUNTRY_ADN;

  return null;
}
